import { EnvConfig } from '@gripp/shared-logic';
import {
  ApplicationInsights,
  DistributedTracingModes,
  ITelemetryItem,
} from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const connectionString = EnvConfig.appInsightsConnectionString;

export const reactPlugin = new ReactPlugin();
export let appInsights: ApplicationInsights | null = null;

if (connectionString) {
  let correlationHeaderDomains: string[] = [];
  try {
    const apiHost = new URL(EnvConfig.apiUrl).hostname;
    if (apiHost) {
      correlationHeaderDomains = [apiHost];
    }
  } catch {
    // apiUrl is empty or malformed in this environment — skip domain correlation
  }

  const instance = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      distributedTracingMode: DistributedTracingModes.W3C,
      enableCorsCorrelation: true,
      correlationHeaderDomains,
      loggingLevelConsole: 0,
      disableFetchTracking: false,
      extensions: [reactPlugin],
    },
  });

  instance.loadAppInsights();

  instance.addTelemetryInitializer((envelope: ITelemetryItem) => {
    if (!envelope.tags) {
      envelope.tags = {};
    }
    envelope.tags['ai.cloud.role'] = 'gripp-web';
    envelope.tags['ai.application.ver'] = EnvConfig.version;
  });

  appInsights = instance;
}
